export default "__VITE_ASSET__CYbnZoSN__"